export const environment = {
  Version: "1.1.0-STAGE-1770170599352",
  production: false,
  CryptoJSKey: "/B?E(H+MbPeShVmYq3t6w9z$C&F)J@NcRfTjWn54kj345gVkXp2s5",
  // DomainFullURL: "https://tableegh.ae/WebApi/api/",
  // DomainURL: "https://tableegh.ae/",
  // FrontkcEndUrl: "https://tableegh.ae",
  DomainFullURL: "https://preprod.tableegh.ae/WebApi/api/",
  DomainURL: "https://preprod.tableegh.ae/",
  FrontEndUrl: "https://preprod.tableegh.ae",
//   DomainFullURL: "http://localhost:59022/api/",
//   DomainURL: "http://localhost:59022/",
//   FrontEndUrl: "http://localhost:4200/",
  // AppName: "Tableegh", 
  firebaseConfig: {
    apiKey: "AIzaSyCSeOmwesIqaFEi2wuC74OgDuFT1APrKpc",
    authDomain: "tableegh-3fb68.firebaseapp.com",
    projectId: "tableegh-3fb68",
    storageBucket: "tableegh-3fb68.appspot.com",
    messagingSenderId: "22465148890",
    appId: "1:22465148890:web:b5d34581bbd98fd166b2e3"
  },
  recaptcha: {
        siteKey: '6Lf7ZrcrAAAAANIo7nkuglXI-imh11KqPYKgG1QN',
    },
};
